import React from "react";

export interface ConsultantSvgIconProps {
  size?: number;
}

const ConsultantSvgIcon: React.FC<ConsultantSvgIconProps> = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    color="currentColor"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Marriage Consultants"
    role="img"
  >
    {/* Person with badge / briefcase — consultant icon */}
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <path d="M14 14l2 2 4-4" />
  </svg>
);

export default ConsultantSvgIcon;
